<!-- ==================== ORIGINAL HTML (COMMENTED) ====================
<div class="modal-body" *ngIf="newEntity">
  ... (original 276 lines)
</ng-template>
==================== END ORIGINAL ==================== -->

<!-- New design-based markup - EDIT CLIENT / NEW CLIENT modal -->
<div class="edit-client-modal" [class.dropdown-open]="businessDropDown" *ngIf="newEntity">
  <!-- No header bar: title top-left, close X top-right -->
  <div class="modal-top-bar">
    <h2 class="modal-title lato-18-b-vw">{{ isEditMode ? 'EDIT CLIENT' : 'NEW CLIENT' }}</h2>
    <button type="button" class="modal-close" aria-label="Close" cygovSvgIcon
      [svgName]="'x-icon-type2'" (click)="modalResult.emit(true)">
    </button>
  </div>

  <!-- Main content: two-column layout -->
  <main class="modal-main">
    <!-- Left column: client details -->
    <section class="left-column">
      <!-- Section 1: Client Name & Industry | Logo (vertical divider between) -->
      <div class="section-card client-section">
        <div class="client-section-row">
          <!-- Left: Client Name + Industry -->
          <div class="client-fields">
            <div class="field">
              <label class="field-label lato-16-b-vw">Client Name <span
                  class="required">*</span></label>
              <input type="text" class="field-input lato-16-n-vw" [(ngModel)]="newEntity.name"
                id="name" spellcheck="true" autocomplete="off" />
            </div>
            <div class="field industry-field industry-dropdown-container">
              <label class="field-label lato-16-b-vw">Industry <span
                  class="required">*</span></label>
              <ng-container *ngIf="businessDropDown">
                <div class="drop-down-backdrop">
                  <div class="custom-dropdown-header">
                    <div class="label-name lato-18-n-vw text-white">Industry</div>

                    <div class="arrow-down lato-16-n-vw" cygovSvgIcon [svgName]="'arrow-down-type1'"
                      (click)="closeBusinessDetailDropdown()"></div>
                  </div>
                  <div class="search-container-wrapper">
                    <div cygovSvgIcon [svgName]="'search-icon'" class="search-icon"></div>
                    <input type="text" placeholder="Search" class="search-text-box"
                      (keyup)="searchInDropdownList($event)">
                  </div>
                </div>
              </ng-container>
              <ng-container
                *ngTemplateOutlet="dropDownInput; context: {$implicit: industryDropdown}"></ng-container>
            </div>
          </div>
          <!-- Right: Logo with edit button (vertical divider on left) -->
          <div class="logo-display">
            <div class="logo-placeholder" *ngIf="!uploadedLogo" (click)="uploadLogo.click()">
              <div class="add-icon" cygovSvgIcon [svgName]="'add-icon'"></div>
              <span class="lato-16-n-vw txt-white">Add Logo</span>
              <input #uploadLogo class="hidden-input" type="file" name="logo"
                accept=".gif, .jpg, .jpeg, .bmp, .tif, .png" (change)="imgHandler($event)" />
            </div>
            <div class="logo-box" *ngIf="uploadedLogo">
              <div class="logo-content">
                <img class="logo-img" [src]="uploadedLogo" alt="{{ newEntity.name }}"
                  *ngIf="uploadedLogo" />
                <span class="logo-name" *ngIf="!uploadedLogo">{{ newEntity.name }}</span>
              </div>
              <button type="button" class="logo-edit" (click)="uploadLogo.click()" cygovSvgIcon
                [svgName]="'edit-button'">
                <input #uploadLogo class="hidden-input" type="file" name="logo"
                  accept=".gif, .jpg, .jpeg, .bmp, .tif, .png" (change)="imgHandler($event)" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Section 2: Solution & Scoring Base -->
      <div class="section-card section-row">
        <div class="solution-section">
          <h3 class="section-title lato-18-b-vw">Solution</h3>
          <div class="checkbox-list">
            <div class="checkbox-item" *ngFor="let key of solutionOrder"
              [class.indent]="solutionObject[key]?.parent">
              <cygov-checkbox [id]="key" [width]="1.9" [height]="1.9" [useViewPortDimensions]="true"
                [isChecked]="solutionObject[key]?.checked"
                (changed)="checkboxChangeHandler($event, { key: key, value: solutionObject[key] })"
                (clicked)="beforeCheckBoxChnaged($event)">
              </cygov-checkbox>
              <span class="checkbox-label" [ngClass]="{
                  'muted': !solutionObject[key]?.checked,
                  'lato-16-n-vw': solutionObject[key]?.parent,
                  'lato-16-b-vw': !solutionObject[key]?.parent
                }" [class.fw-300]="solutionObject[key]?.parent">
                {{ solutionObject[key].name }}
              </span>
            </div>
          </div>
        </div>
        <div class="scoring-section">
          <h3 class="section-title lato-16-b-vw">Scoring Base</h3>
          <div class="radio-group type-radio round-checkbox">
            <span class="radio-span-setting-options"
              *ngFor="let option of scoringBaseOptions; let idx = index">
              <input type="radio" class="question-type-checkbox" name="scoring-base"
                [value]="option.value" [checked]="option.checked"
                (change)="scoringBaseChangeHandler($event, option)" [id]="'scoring-base' + idx">
              <label [for]="'scoring-base' + idx" class="label netskope-overview lato-16-n-vw">
                {{ option.name }}
              </label>
            </span>
          </div>
        </div>
      </div>

      <!-- Section 3: 1st Party -->
      <div class="section-card party-section" [class.disabled]="!solutionObject.firstParty.checked">
        <h3 class="section-title lato-18-b-vw">1st Party</h3>
        <div class="toggle-row attack-surface-row">
          <div class="toggle-btn" [style.z-index]="businessDropDown ? '-1' : ''">
            <cygov-toggle-button [id]="'1'" [isChecked]="newEntity.domainScanEnabledForEntity"
              (changed)="newEntity.domainScanned = !newEntity.domainScanned; newEntity.domainScanEnabledForEntity = newEntity.domainScanned; newEntity.domainScanned === false && (this.DomainScanValue = null)">
            </cygov-toggle-button>
          </div>
          <span class="toggle-label lato-16-b-vw" [class.muted]="!newEntity.domainScanned">Attack
            Surface</span>
          <div class="attack-surface-input">
            <input type="text" class="field-input lato-16-n-vw" [(ngModel)]="this.DomainScanValue"
              [disabled]="!newEntity.domainScanned" placeholder="URL">
          </div>
        </div>
        <div class="divider"></div>
        <div class="counter-row">
          <div class="counter-label" style="margin-right: 2vw;">
            <span class="lato-16-b-vw txt-white">Number of AI Credits</span>
            <div class="info-icon-ai-credits" cygovSvgIcon [svgName]="'info-board-icon'"
              [ngbTooltip]="'Available in packages of 100'" [placement]="'right'"
              tooltipClass="tooltip-ai-credits"></div>
          </div>
          <ng-container
            *ngTemplateOutlet="counterItem; context: { $implicit: newEntity?.AI?.credits, label: 'AI_CREDITS' }"></ng-container>
        </div>
      </div>

      <!-- Section 4: Regulatory Watch -->
      <div class="section-card party-section"
        [class.disabled]="!solutionObject.regulatoryWatch?.checked">
        <h3 class="section-title lato-16-b-vw">Regulatory Watch</h3>
        <div class="counter-row">
          <div class="counter-label" style="margin-right: 2.7vw;">
            <span class="lato-16-b-vw txt-white">Number of Regulations</span>
            <!-- <div class="info-icon-ai-credits" cygovSvgIcon [svgName]="'info-board-icon'"
              [ngbTooltip]="'Available in packages of 50'" [placement]="'right'"
              tooltipClass="tooltip-ai-credits"></div> -->
          </div>
          <ng-container
            *ngTemplateOutlet="counterItem; context: { $implicit: newEntity?.regulatoryWatch?.credits, label: 'REGULATIONS_COUNT' }"></ng-container>
        </div>
      </div>

      <!-- Section 5: 3rd Party -->
      <div class="section-card party-section" [class.disabled]="!solutionObject.thirdParty.checked">
        <h3 class="section-title lato-18-b-vw">3rd Party</h3>
        <div class="counter-row">
          <div class="counter-label" style="margin-right: 2.6vw;">
            <span class="lato-16-b-vw txt-white">Number of Vendors</span>
            <div class="info-icon-ai-credits" cygovSvgIcon [svgName]="'info-board-icon'"
              [ngbTooltip]="'Available in packages of 50'" [placement]="'right'"
              tooltipClass="tooltip-ai-credits"></div>
          </div>
          <ng-container
            *ngTemplateOutlet="counterItem; context: { $implicit: newEntity?.vendors?.vendorsTotalCount, label: 'VENDORS_COUNT' }"></ng-container>
        </div>
      </div>

      <!-- Centraleyes API -->
      <div class="section-card api-section">
        <cygov-toggle-button [id]="'2'" [isChecked]="newEntity.isCentraleyesApiEnabled"
          (changed)="newEntity.isCentraleyesApiEnabled = !newEntity.isCentraleyesApiEnabled">
        </cygov-toggle-button>
        <span class="toggle-label">Centraleyes API</span>
      </div>
    </section>

    <!-- Right column: frameworks + actions section card -->
    <section class="right-column">
      <div class="section-card framework-section" [class.not-edit-mode]="!isEditMode">
        <cygov-domain-frameworks-listings [isFirstPartyOn]="solutionObject.firstParty.checked"
          [isThirdPartyOn]="solutionObject.thirdParty.checked" [title]="'Choose framework'"
          [riskFrameWorkItems]="riskFrameWorkOpt" [complianceItems]="standardList"
          [vendorFrameworkItems]="vendorList" (clickOnSaveButton)="emitEntity($event)"
          [showCheckbox]="true" [isSelectAllVisible]="true" [disableActiveHighlight]="true"
          [toggleActiveTextColor]="'#C5C9D1'" [toggleInactiveTextColor]="'#C5C9D1'"
          [isLoading]="isLoadingFrameworks" [showFrameworkCounts]="true">
        </cygov-domain-frameworks-listings>
      </div>
      <div class="section-card actions-section" *ngIf="isEditMode">
        <div class="right-column-actions">
          <span class="delete-client-text" (click)="deleteClientModal()" [style.color]="'#F75F57'">
            <span class="delete-client-icon" cygovSvgIcon [svgName]="'trash-icon'"></span>
            <span class="lato-16-b-vw">Delete Client</span>
          </span>
        </div>
      </div>
    </section>
  </main>

  <!-- Footer: SAVE / ADD CLIENT right-aligned -->
  <footer class="modal-footer">
    <cygov-button [buttonText]="isEditMode ? 'SAVE' : 'ADD CLIENT'"
      [buttonWidth]="isEditMode ? '6vw' : '6.6vw'" [buttonColor]="'#29a9eb'"
      [hoverColor]="'#0F92E3'" [textSize]="'14'"
      (click)="isValid(newEntity) && saveButtonClicked()">
    </cygov-button>
  </footer>
</div>

<!-- Dropdown template (reused) - original structure -->
<ng-template #dropDownInput let-obj>
  <div class="custom-drop-down" [ngClass]="{ 'paddting-top-business': businessDropDown}">
    <div class="drop-down-label lato-16-n-vw" (click)="openBusinessDropdown(obj)"
      [ngClass]="{'drop-down-opened': obj.isDropDownOpened, 'placeholder-color': !obj.value}">
      <div class="drop-down-label-text text-ellipsis">{{ obj.value ? obj.value : 'Choose' }}</div>
      <div class="arrow-icon-right" cygovSvgIcon [svgName]="'arrow-right-type3'"></div>
    </div>
    <ng-container *ngIf="obj.isDropDownOpened">
      <div class="expanded-list" [ngClass]="{'expanded-list-opened': obj.isDropDownOpened}">
        <div *ngFor="let item of obj.searchList; let indx = index" class="expanded-list-item">
          <span class="item lato-12-n-vw" (click)="saveBusinessDropdownItem(obj, indx)"
            [ngClass]="{'blue-text': obj.value === item.name}">{{ item.name }}</span>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>

<!-- Counter template - original structure for proper icon styling -->
<ng-template #counterItem let-credits let-label="label">
  <div class="counter">
    <div class="incrementor-decrementor-wrapper" (click)="decrement(label, counterInput)"
      [class.decremental-disabled]="(label === 'AI_CREDITS' && credits === 100) || (label === 'VENDORS_COUNT' && credits === 50) || (label === 'REGULATIONS_COUNT' && credits === 25)">
      <div class="decrementor" cygovSvgIcon [svgName]="'arrow-down-type1'"></div>
    </div>
    <input #counterInput class="counter-value lato-16-n-vw" type="number" [value]="credits" min="0"
      [readonly]="label !== 'REGULATIONS_COUNT'"
      (change)="label === 'REGULATIONS_COUNT' && onRegulationsCountChange(counterInput)" />
    <div class="incrementor-decrementor-wrapper" (click)="increment(label, counterInput)">
      <div class="incrementor" cygovSvgIcon [svgName]="'arrow-up-type1'"></div>
    </div>
  </div>
</ng-template>